import {Competition, Participation, ParticipationError} from "./models";
import config from "../../config";
import {getCustomerService} from "../customer/customer-service";
import {RegisterNewsletterRequest} from "../customer/newsletter";
import {getCountryService} from "../country/country-service";

export const COMPETITION_SERVICE_KEY = 'NY_COMPETITION_SERVICE';

declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Window {
    NY_COMPETITION_SERVICE: ICompetitionService;
  }
}

interface ICompetitionService {
  loadCompetition(id: string): Promise<Competition>;
  participate(competitionId: string, participation: Participation): Promise<void>;
}

export function getCompetitionService(): ICompetitionService {
  const cs = window[COMPETITION_SERVICE_KEY];
  if (cs) {
    return cs as ICompetitionService;
  }
  return null
}

export class CompetitionService implements ICompetitionService {

  async loadCompetition(id: string): Promise<Competition> {
    const response = await fetch(`${config.competitionServiceUrl}/competition/${id}`);
    if (!response.ok) {
      throw new Error("error loading competition: " + response.statusText);
    }
    const data = await response.json();
    return new Competition(data);
  }

  async participate(competitionId: string, participation: Participation) {
    const response = await fetch(`${config.competitionServiceUrl}/competition/${competitionId}/participate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(participation)
    });
    if (!response.ok) {
      const data = await response.json();
      console.error("error participating in competition: " + data.message);
      throw new ParticipationError(data.code, data.message);
    }
    if (participation.termsAdvertisement) {
      //subscribe to newsletter
      const countryCode = getCountryService()?.getCountryCodeFromUrl() || 'DE';

      const newsletterRequest = new RegisterNewsletterRequest()
      newsletterRequest.email = participation.email;
      newsletterRequest.countryCode = countryCode;
      newsletterRequest.optInEmailAdvertisementConsent = participation.termsAdvertisement;
      newsletterRequest.optInEmailChannelNewsletter = participation.termsAdvertisement;
      newsletterRequest.optInEmailChannelMensFashion = true;
      newsletterRequest.optInEmailChannelWomensFashion = true;

      try {
        await getCustomerService()?.subscribeForNewsletter(newsletterRequest);
      } catch (e) {
        console.error("error subscribing for newsletter in competition: ", e);
      }
    }
  }
}
